angular.module('rinca.config', [])
    .run(['$rootScope', 'config', function ($rootScope, config) {
        $rootScope.config = config || {};
    }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/config.ts
// module id = 284
// module chunks = 0